module.exports = __webpack_public_path__ + "static/media/logo.0fa65549.jpg";